import { defaultRegisterForm } from "../../Auth/redux/initialState";
import { paymentMethodType } from "../../Products/Cart/types";
import {
  IEmail,
  IOrder,
  IPassword,
  OrderStatusType,
  ProfileState,
} from "../types";

export const defaultEmailForm: IEmail = {
  email: "",
  confirmEmail: "",
};

export const defaultPassword: IPassword = {
  oldPassword: "",
  newPassword: "",
  confirmPassword: "",
};
export const defaultOrderDetails: IOrder = {
  _id: "",
  orderId: "",
  status: OrderStatusType.ACCEPTED,
  payment_status: "",
  subTotal: 0,
  totalShipmentCapacity: 0,
  shipmentCharges: 0,
  totalPrice: 0,
  taxAmount: 0,
  firstName: "",
  lastName: "",
  japaneseFirstName: "",
  japaneseLastName: "",
  postCode: "",
  state: "",
  district: "",
  streetAddress: "",
  mobileNumber: "",
  email: "",
  companyName: "",
  japaneseCompanyName: "",
  department: "",
  alternateFirstName: "",
  alternateLastName: "",
  alternateJapaneseFirstName: "",
  alternateJapaneseLastName: "",
  alternatePostCode: "",
  alternateState: "",
  alternateDistrict: "",
  alternateStreetAddress: "",
  alternateMobileNumber: "",
  alternateCompanyName: "",
  alternateJapaneseCompanyName: "",
  alternateDepartment: "",
  remarks: "",
  deliveryTimeSlot: "",
  paymentMethod: paymentMethodType.cash_on_delivery,
  order_items: [],
  createdAt: "",
  updatedAt: "",
  deliveryCompany: "",
  estimatedDeliveryDate: "",
  trackingUrl: "",
  trackingNo: ""
};

export const initialState: ProfileState = {
  password: {
    ...defaultPassword,
  },
  registerForm: { ...defaultRegisterForm },
  emailForm: { ...defaultEmailForm },
  loading: false,
  togglePassword: false,
  toggleConfirmPassword: false,
  buttonLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 10,
  totalRow: 0,
  orderBy: "",
  orderDir: "asc",
  orderList: [],
  orderDetails: {
    ...defaultOrderDetails,
  },
  holdUpdatedItems: [],
  notificationList: [],
  totalCount: 0
};
